import { useLocation } from "react-router-dom";

export default function useQuery(): URLSearchParams {
	const loc = useLocation();
	return new URLSearchParams(loc.search);
}
